<div class="indexing-dialog">
  <h2 mat-dialog-title>Indexation des articles</h2>

  <mat-dialog-content>
    <mat-tab-group>
      <mat-tab label="Nouvelle indexation">
        <div class="tab-content">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Pourcentage d'indexation</mat-label>
            <input
              [formControl]="pourcentageControl"
              matInput
              type="number"
              min="0"
              max="100"
              step="0.01"
              placeholder="Ex: 2.5"
            />
            <span matSuffix>%</span>
            <mat-hint>Entrez le pourcentage d'indexation à appliquer</mat-hint>
          </mat-form-field>
        </div>
      </mat-tab>

      <mat-tab label="Historique">
        <div class="tab-content">
          <div class="table-container" *ngIf="history && history.length > 0">
            <table
              mat-table
              [dataSource]="dataSource"
              class="history-table"
              matSort
            >
              <ng-container matColumnDef="createdOn">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
                <td mat-cell *matCellDef="let item">
                  {{ item.createdOn | date: "dd/MM/yyyy" }}
                </td>
              </ng-container>

              <ng-container matColumnDef="percentage">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Pourcentage
                </th>
                <td mat-cell *matCellDef="let item">
                  <strong>{{ item.percentage }}%</strong>
                </td>
              </ng-container>
              <tr
                mat-header-row
                *matHeaderRowDef="displayedColumns; sticky: true"
              ></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>

            <mat-paginator
              [pageSizeOptions]="[5, 10, 20, 50]"
              showFirstLastButtons
              [length]="history.length"
              class="paginator"
            ></mat-paginator>
          </div>

          <div class="no-history" *ngIf="!history || history.length === 0">
            <mat-icon>history</mat-icon>
            <p>Aucune indexation enregistrée</p>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">Annuler</button>
    <button
      mat-raised-button
      color="primary"
      [disabled]="pourcentageControl.invalid"
      (click)="onValidate()"
    >
      Valider
    </button>
  </mat-dialog-actions>
</div>
